
import {
  Component,
  Vue,
  Prop,
  Model,
  Emit,
  Watch
} from "vue-property-decorator";
import ModalHeader from "@/components/modal-header.vue";
import ModalTitle from "@/lib/model/exam/modal-title";
import Auth from "@/lib/common/auth";
import {
  CandidateTagList,
  CandidateTags
} from "@/lib/form/candidate/CandidateListForm";
import ExamList, { CompanyIdParam } from "@/lib/model/exam/exam";

import Candidate, { CandidateGet } from "@/lib/model/exam/candidate";
import { EnumTagType, EnumTagMap } from "@/lib/enum/tags";

@Component({
  components: {
    ModalHeader
  }
})
export default class AddCandidateTags extends Vue {
  name = "add-candidate-tags";
  @Prop() selectedIdList!: number[];
  @Prop({ default: true }) showAddTag!: boolean;
  @Prop({ default: "" }) connectCode!: string;
  @Prop({ default: "" }) judgeOutId!: string;
  @Prop({ default: "" }) passwd!: string;
  @Prop({ default: false }) isHrsPage!: boolean;
  @Prop({ default: EnumTagType.EnumTagTypeDefault }) tagType!: number;
  tagList: string[] = [];

  auditStatus = 1;
  auditDesc = "";
  candidateTag: string[] = [];
  companyIdParam = new CompanyIdParam();

  modalTitle: ModalTitle = new ModalTitle();
  candidateTagsList = new CandidateTags();
  selectNum = 1;
  candidateGetForm = new CandidateGet();

  mounted() {
    console.log("this.selectedIdList: ", this.selectedIdList);
    this.modalTitle.title = "添加标签";
    this.modalTitle.hasDesc = false;
    this.candidateTagsList.companyId = Auth.companyId;
  }

  created() {
    // 单人添加标签，加载已有标签
    if (this.selectedIdList.length === 1) {
      // this.getCandidateInfo();
    }
    this.getTagList();
  }

  getTagList() {
    const params = {
      companyId: Auth.companyId,
      connectCode: this.connectCode,
      judgeOutId: this.judgeOutId,
      passwd: this.passwd
    };
    ExamList[this.isHrsPage ? "getHrTags" : "companyTags"](params).then(res => {
      if (res.code === 0) {
        this.tagList = res.data.tag;
      }
    });
  }

  mouseEnterAction() {
    const inputBox: HTMLInputElement = this.$refs
      .selectblur as HTMLInputElement;
    inputBox.blur();
  }

  getCandidateInfo() {
    this.candidateGetForm.candidateId = this.selectedIdList[0];
    this.candidateGetForm.companyId = parseInt(Auth.companyId);
    Candidate.getCandidateInfo(this.candidateGetForm).then(resp => {
      console.log("getCandidateInfo: ", resp);
      const type = EnumTagMap[this.tagType];
      this.candidateTag = resp.data[type];
    });
  }

  handleClose() {
    this.tagCancel();
  }

  tagAddSubmit() {
    if (this.selectedIdList.length) {
      //评估页走接口
      if (this.isHrsPage) {
        const params = {
          connectCode: this.connectCode,
          judgeOutId: this.judgeOutId,
          passwd: this.passwd,
          tags: this.candidateTag,
          tagType: this.tagType
        };

        ExamList.setHrTags(params).then(res => {
          if (res.code === 0) {
            this.$message.success("添加成功");
            this.tagSubmit(res.data.tags);
          }
        });
      } else {
        //列表页走接口
        const candidateListParam: any[] = [];
        this.selectedIdList.forEach((item: number, key: number) => {
          const candidateTagList = new CandidateTagList();
          candidateTagList.candidateId = item;
          candidateTagList.tags = this.candidateTag;
          candidateListParam.push(candidateTagList);
        });
        this.candidateTagsList.candidateList = candidateListParam;
        this.candidateTagsList.tagType = this.tagType;

        ExamList.candidateMSetTags(this.candidateTagsList).then(res => {
          if (res.code === 0) {
            this.$message.success("添加成功");
            this.tagSubmit();
          }
        });
      }
    } else {
      this.$message.info("您还没有选择需要设置标签的候选人");
    }
  }

  @Emit("on-submit-tag")
  tagSubmit(tags?: []) {
    return tags;
  }

  @Emit("on-cancel-tag")
  tagCancel() {
    console.log("on-cancel-audit");
  }
}
